module.exports = __webpack_public_path__ + "img/performance-10.32ce90a0.png";